var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentBox"},[_c('div',{staticClass:"contentBlock fade-in-section"},[_c('img',{staticClass:"bannerImgItem",attrs:{"src":_vm.bannerImg}})]),_c('div',{staticClass:"contentBlock fade-in-section"},[_c('div',{staticClass:"RichText",domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }